/**
 * E.g. Convert "camelCaseToSentenceCase" to "Camel Case To Sentence Case"
 *
 * @param text
 */
export default (text) => {
  const addSpaces = text.replace(/([A-Z])/g, ' $1');
  return addSpaces.charAt(0).toUpperCase() + addSpaces.slice(1);
};